import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, SimpleChanges, inject, signal } from '@angular/core';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { HasRolesDirective } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';
import { LoadingErrorComponent } from 'src/app/components/loading-error/loading-error.component';
import { ToastComponent } from 'src/app/components/toast/toast.component';
import { ClientApplication, DetectSimulation, Policy, RequestSimulation, ResultSimulation } from 'src/app/service/global.service';
import { ToastService } from 'src/app/service/toast.service';
import { TranslationService } from 'src/app/service/translation.service';


@Component({
    selector: 'app-simulation-results',
    templateUrl: './simulation-results.component.html',
    styleUrls: ['./simulation-results.component.scss'],
    providers: [DatePipe, ToastService, TranslationService],
    imports: [
      CommonModule,
      HasRolesDirective,
      TranslateModule,
      ToastComponent,
      LoadingErrorComponent,
      NgbPopoverModule
    ],
    standalone: true
})
export class SimulationResultsComponent {
  @Input() requestParam?: { id: number, body: RequestSimulation };
  @Input() appSelected?: ClientApplication;
  @Input() policySelected?: Policy;
  @Output() close = new EventEmitter<string>();

  readonly resultSimulation = signal<ResultSimulation | undefined>(undefined);
  readonly lnewDetect = signal<DetectSimulation[] | undefined>(undefined);
  readonly lactualDetect = signal<DetectSimulation[] | undefined>(undefined);
  readonly loadingOerror = signal<boolean>(true);
  readonly initialized = signal<boolean>(false);

  readonly datepipe = inject(DatePipe);
  readonly toastService = inject(ToastService);
  readonly translationService = inject(TranslationService);
  readonly keycloak = inject(Keycloak);

  async ngOnInit() {
    await this.loadSimulation();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.initialized() && changes) {
      await this.loadSimulation();
    }
  }

  private async loadSimulation() {
    this.loadingOerror.set(true);
    try {
      if (this.requestParam) {
        const result = await Backend.POLICIES.requestSimulation(this.requestParam);
        this.resultSimulation.set(result);
        this.lnewDetect.set(Backend.POLICIES.parseDetect(result.mapDetNew));
        this.lactualDetect.set(Backend.POLICIES.parseDetect(result.mapDetActual));
        this.initialized.set(true);
        this.loadingOerror.set(false);
      }
    } catch (e) {
      const err = e as HttpErrorResponse;
      this.translationService.get('simulation-error').subscribe(msg => {
        this.toastService.show(
          err.error?.message || msg,
          { classname: 'bg-danger', delay: 5000 }
        );
      });
      this.close.emit("close");
    }
  }

  public calcPourcentage(a: number | undefined, b: number | undefined): number {
    if (typeof a === 'number' && typeof b === 'number' && (a + b) > 0) {
      return a / (a + b);
    }
    return 0;
  }

  public getCurrentPolicyActivated(): Policy | undefined {
    return this.appSelected?.policy?.find(elem => elem.status === "ACTIVATED");
  }

  public setClass(a: number | undefined, b: number | undefined): string {
    if (typeof a === 'number' && typeof b === 'number') {
      if (a > b) {
        return 'danger';
      } else {
        return 'success';
      }
    }
    return '';
  }

  public formatDate(date: Date | undefined): string | undefined {
    if (date) {
      const result = Backend.FORMAT.onlyDate(date.getTime(), this.datepipe);
      return result ?? undefined;
    }
    return undefined;
  }

  getRoleDetectorViewer(): boolean {
    return this.keycloak.hasRealmRole('bo-dip-technical-detectors-viewer');
  }
}
